import React, { useState } from 'react';
import styled from 'styled-components';
import promotionLeft from '../images/promotion-left.png';
import promotionRight from '../images/promotion-right.png';
import thumb from '../images/thumb.png';
import testimonial1 from '../images/testimonial1.png';
import testimonial2 from '../images/testimonial2.png';
import testimonial3 from '../images/testimonial3.png';
import testimonial4 from '../images/testimonial4.png';

const Pricing: React.FC = () => {
  const [plan1Yearly, setPlan1Yearly] = useState(true);
  const [plan2Yearly, setPlan2Yearly] = useState(true);
  const [plan3Yearly, setPlan3Yearly] = useState(true);

  // 각 요금제별 가격 계산 함수
  const getPrice = (planIndex: number, isYearly: boolean) => {
    const yearlyPrices = [200, 225, 270];
    const monthlyPrices = [220, 250, 300];
    return isYearly ? yearlyPrices[planIndex] : monthlyPrices[planIndex];
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const button = form.querySelector('.submit-button') as HTMLButtonElement;
    const originalText = button.textContent || '';
    
    button.textContent = '전송 중...';
    button.disabled = true;
    
    setTimeout(() => {
      button.textContent = '전송 완료!';
      button.style.background = '#4ade80';
      
      form.reset();
      
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        button.style.background = '';
      }, 3000);
    }, 1500);
  };

  return (
    <MainContainer>
      <TitleSection>
        <div className="container">
          <PageTitle>
            <DailyHighlight>매일</DailyHighlight>의 식품 폐기물,<br />
            <PriceHighlight>더 효율적이고 투명한 가격</PriceHighlight>으로 관리하세요!
          </PageTitle>
        </div>
      </TitleSection>

      <PricingSection>
        <div className="container">
          <PricingGrid>
            <PricingCard>
              <PlanHeader>
                <PlanBadge>요금제 1</PlanBadge>
                <PlanYearly>
                  {plan1Yearly ? '연간' : '월간'}
                  <Switch>
                    <input type="checkbox" checked={plan1Yearly} onChange={() => setPlan1Yearly(!plan1Yearly)} />
                    <Slider />
                  </Switch>
                </PlanYearly>
              </PlanHeader>
              <PlanPrice>{getPrice(0, plan1Yearly)}원<PlanUnit>/L</PlanUnit></PlanPrice>
              <PlanFeatures>
                <li><CheckIcon>✓</CheckIcon> 수거 일정 자유 지정 서비스 제공</li>
                <li><CheckIcon>✓</CheckIcon> 비전 AI기반 과금 시스템 제공</li>
                <li><CheckIcon>✓</CheckIcon> 기본 고객 지원</li>
                <li><CheckIcon>✓</CheckIcon> 배출량 통계 제공</li>
              </PlanFeatures>
              <PlanButton>문의하기</PlanButton>
            </PricingCard>

            <PricingCard $featured>
              <PlanHeader>
                <PlanBadge>요금제 2</PlanBadge>
                <PlanYearly>
                  {plan2Yearly ? '연간' : '월간'}
                  <Switch>
                    <input type="checkbox" checked={plan2Yearly} onChange={() => setPlan2Yearly(!plan2Yearly)} />
                    <Slider />
                  </Switch>
                </PlanYearly>
              </PlanHeader>
              <PlanPrice>{getPrice(1, plan2Yearly)}원<PlanUnit>/L</PlanUnit></PlanPrice>
              <PlanFeatures>
                <li><CheckIcon>✓</CheckIcon> 수거 일정 자유 지정 서비스 제공</li>
                <li><CheckIcon>✓</CheckIcon> 비전 AI기반 과금 시스템 제공 및 분석 보고서 제공</li>
                <li><CheckIcon>✓</CheckIcon> 포인트 적립</li>
                <li><CheckIcon>✓</CheckIcon> ESG 보고서 제공</li>
                <li><CheckIcon>✓</CheckIcon> 우선 지원 서비스</li>
                <li><CheckIcon>✓</CheckIcon> 상세한 배출량 트렌드 분석</li>
              </PlanFeatures>
              <PlanButton>문의하기</PlanButton>
            </PricingCard>

            <PricingCard>
              <PlanHeader>
                <PlanBadge>요금제 3</PlanBadge>
                <PlanYearly>
                  {plan3Yearly ? '연간' : '월간'}
                  <Switch>
                    <input type="checkbox" checked={plan3Yearly} onChange={() => setPlan3Yearly(!plan3Yearly)} />
                    <Slider />
                  </Switch>
                </PlanYearly>
              </PlanHeader>
              <PlanPrice>{getPrice(2, plan3Yearly)}원<PlanUnit>/L</PlanUnit></PlanPrice>
              <PlanFeatures>
                <li><CheckIcon>✓</CheckIcon> 수거 일정 자유 지정 서비스 제공</li>
                <li><CheckIcon>✓</CheckIcon> 긴급 수거 서비스 추가 제공</li>
                <li><CheckIcon>✓</CheckIcon> 비전 AI기반 과금 시스템 제공 및 분석 보고서 제공</li>
                <li><CheckIcon>✓</CheckIcon> 배출량 예측 데이터 제공</li>
                <li><CheckIcon>✓</CheckIcon> 식품 폐기물 데이터 기반 원재료 최적화 리포트 제공</li>
                <li><CheckIcon>✓</CheckIcon> 맞춤형 데이터 대시보드 및 실시간 배출량 분석</li>
                <li><CheckIcon>✓</CheckIcon> 고급 포인트 적립 및 특별 보너스 포인트 제공</li>
                <li><CheckIcon>✓</CheckIcon> ESG 보고서 제공</li>
                <li><CheckIcon>✓</CheckIcon> 전담 고객 관리 서비스</li>
              </PlanFeatures>
              <PlanButton>문의하기</PlanButton>
            </PricingCard>
          </PricingGrid>
        </div>
      </PricingSection>

      <PromotionSection>
        <div className="container">
          <PromotionTitle>한정프로모션/할인 이벤트</PromotionTitle>
          
          <PromotionGrid>
            <PromotionCard>
              <PromotionBadge>연간 결제 할인 이벤트</PromotionBadge>
              <PromotionContent>
                <PromotionYear>2025년 이용 고객</PromotionYear>
                <PromotionCondition>연간 결제 시</PromotionCondition>
                <PromotionDiscount>10% 추가할인!!</PromotionDiscount>
              </PromotionContent>
              <PromotionImageWrapper>
                <img src={promotionLeft} alt="2025년 프로모션" />
              </PromotionImageWrapper>
            </PromotionCard>

            <PromotionCard>
              <PromotionBadge>묶어묶어 이벤트</PromotionBadge>
              <PromotionContent>
                <PromotionYear>같은 지역 고객이</PromotionYear>
                <PromotionCondition>합께 묶어</PromotionCondition>
                <PromotionCondition>2인 이상이면</PromotionCondition>
                <PromotionDiscount>최대 10% 할인!!</PromotionDiscount>
              </PromotionContent>
              <PromotionImageWrapper>
                <img src={promotionRight} alt="지역 할인 프로모션" />
              </PromotionImageWrapper>
            </PromotionCard>
          </PromotionGrid>
        </div>
      </PromotionSection>

      <CXSection>
        <div className="container">
          <CXContent>
            <CXLeft>
              <CXBadge>CX</CXBadge>
              <CXTitle>
                아직 이용이 망설여진다면?<br />
                <CXHighlight>걱정하지 마세요!</CXHighlight>
              </CXTitle>
              <CXStats>
                <CXStat>
                  <CXNumber>30일</CXNumber>
                  <CXLabel>서비스가 마음에 들지 않으면 30일 내 무조건 환불 보장</CXLabel>
                </CXStat>
                <CXStat>
                  <CXNumber>2주</CXNumber>
                  <CXLabel>2주간 무료 체험 혜택까지!</CXLabel>
                </CXStat>
              </CXStats>
            </CXLeft>
            <CXRight>
              <CXThumbContainer>
                <img src={thumb} alt="엄지척" />
              </CXThumbContainer>
            </CXRight>
          </CXContent>
        </div>
      </CXSection>

      <TestimonialSection>
        <div className="container">
          <TestimonialHeader>
            <TestimonialBadge>TESTIMONIAL</TestimonialBadge>
            <TestimonialTitle>다른 고객님은 왜 <TestimonialHighlight>쓸모</TestimonialHighlight>로 바꿨을까요?</TestimonialTitle>
          </TestimonialHeader>
          
          <TestimonialGrid>
            <TestimonialCard>
              <img src={testimonial1} alt="정주시장 후기" />
            </TestimonialCard>

            <TestimonialCard>
              <img src={testimonial2} alt="계룡건설 후기" />
            </TestimonialCard>

            <TestimonialCard>
              <img src={testimonial3} alt="이레정과 후기" />
            </TestimonialCard>

            <TestimonialCard>
              <img src={testimonial4} alt="백화원 후기" />
            </TestimonialCard>
          </TestimonialGrid>
        </div>
      </TestimonialSection>

      <ContactSection>
        <div className="container">
          <ContactContent>
            <ContactText>
              <h2>
                고객님의 사업장이<br />
                <ContactHighlight>쓸모</ContactHighlight>를 만나면<br />
                무엇이 달라질까요?
              </h2>
              <p>더 깔끔하게, 더 정확하게, 더 효율적으로 지금부터 쓸모를 시작해보세요.</p>
            </ContactText>
            
            <ContactForm onSubmit={handleSubmit}>
              <FormGroup>
                <FormLabel htmlFor="name">성함</FormLabel>
                <FormInput type="text" id="name" name="name" placeholder="김쓸모" required />
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="company">사업장 지역</FormLabel>
                <FormInput type="text" id="company" name="company" placeholder="충북 청주" required />
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="phone">연락처</FormLabel>
                <FormInput type="tel" id="phone" name="phone" placeholder="010-0000-0000" required />
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="email">이메일</FormLabel>
                <FormInput type="email" id="email" name="email" placeholder="abc@zero1ne.com" required />
              </FormGroup>
              <SubmitButton type="submit" className="submit-button">제출하기</SubmitButton>
            </ContactForm>
          </ContactContent>
        </div>
      </ContactSection>
    </MainContainer>
  );
};

// Styled Components
const MainContainer = styled.main`
  background: #21004d;
  min-height: 100vh;
`;

const TitleSection = styled.div`
  padding-top: 150px;
  padding-bottom: 80px;
  text-align: center;

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 105px;

    @media (max-width: 1024px) {
      padding: 0 32px;
    }

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }
`;

const PageTitle = styled.h1`
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 60px;
  font-weight: normal;
  margin: 0;
  line-height: 1.2;
  color: white;

  @media (max-width: 768px) {
    font-size: 40px;
  }

  @media (max-width: 480px) {
    font-size: 32px;
  }
`;

const DailyHighlight = styled.span`
  color: #ebb800;
`;

const PriceHighlight = styled.span`
  color: #eb6200;
`;

const PricingSection = styled.section`
  background: #21004d;
  padding: 0 0 100px;

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 105px;

    @media (max-width: 1024px) {
      padding: 0 32px;
    }

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }
`;

const PricingGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const PricingCard = styled.div<{ $featured?: boolean }>`
  background: #2a0061;
  border-radius: 20px;
  padding: 40px 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const PlanHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

const PlanBadge = styled.div`
  color: #eb6200;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 28px;
  font-weight: normal;
`;

const PlanYearly = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 24px;
  font-weight: normal;
`;

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #666;
  transition: 0.4s;
  border-radius: 24px;
  
  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + & {
    background-color: #eb6200;
  }

  input:checked + &:before {
    transform: translateX(26px);
  }
`;

const PlanPrice = styled.div`
  color: white;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 48px;
  font-weight: normal;
  margin-bottom: 40px;
`;

const PlanUnit = styled.span`
  font-size: 24px;
  color: rgba(255, 255, 255, 0.8);
`;

const PlanFeatures = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
  flex: 1;
  
  li {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    color: white;
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 16px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const CheckIcon = styled.span`
  color: #ebb800;
  font-weight: bold;
  font-size: 18px;
  margin-top: 2px;
  flex-shrink: 0;
`;

const PlanButton = styled.button`
  width: 100%;
  background: #eb6200;
  color: black;
  border: none;
  border-radius: 12px;
  padding: 16px 24px;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 20px;
  font-weight: normal;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: auto;
  
  &:hover {
    background: #d55400;
    transform: translateY(-2px);
  }
`;

const PromotionSection = styled.section`
  background: #21004d;
  padding: 100px 0;

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 105px;

    @media (max-width: 1024px) {
      padding: 0 32px;
    }

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }
`;

const PromotionTitle = styled.div`
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 38px;
  font-weight: normal;
  color: #eb6200;
  text-align: center;
  margin-bottom: 60px;

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

const PromotionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const PromotionCard = styled.div`
  background: #2a0061;
  border-radius: 20px;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const PromotionBadge = styled.div`
  color: #ebb800;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 38px;
  font-weight: normal;
  text-align: left;
  margin-bottom: 40px;
`;

const PromotionContent = styled.div`
  text-align: left;
  margin-bottom: 40px;
`;

const PromotionYear = styled.div`
  color: white;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 60px;
  font-weight: normal;
  margin-bottom: 10px;
  line-height: 1.2;
`;

const PromotionCondition = styled.div`
  color: white;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 60px;
  font-weight: normal;
  margin-bottom: 10px;
  line-height: 1.2;
`;

const PromotionDiscount = styled.div`
  color: #eb6200;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 60px;
  font-weight: normal;
  line-height: 1.2;
`;

const PromotionImageWrapper = styled.div`
  width: 100%;
  height: 480px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const CXSection = styled.section`
  background: #2a0061;
  padding: 100px 0;

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 105px;

    @media (max-width: 1024px) {
      padding: 0 32px;
    }

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }
`;

const CXContent = styled.div`
  display: flex;
  align-items: center;
  gap: 80px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 60px;
  }
`;

const CXLeft = styled.div`
  flex: 1;
`;

const CXBadge = styled.div`
  display: inline-block;
  background: #ebb800;
  color: #000;
  padding: 8px 24px;
  border-radius: 50px;
  border: 3px solid #eb6200;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 24px;
  font-weight: normal;
  margin-bottom: 40px;
`;

const CXTitle = styled.h3`
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 60px;
  font-weight: normal;
  color: white;
  line-height: 1.3;
  margin-bottom: 60px;

  @media (max-width: 768px) {
    font-size: 48px;
  }

  @media (max-width: 480px) {
    font-size: 36px;
  }
`;

const CXHighlight = styled.span`
  color: #eb6200;
`;

const CXStats = styled.div`
  display: flex;
  gap: 80px;

  @media (max-width: 768px) {
    gap: 40px;
  }

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 40px;
  }
`;

const CXStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CXNumber = styled.span`
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 96px;
  font-weight: normal;
  color: #eb6200;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 72px;
  }

  @media (max-width: 480px) {
    font-size: 56px;
  }
`;

const CXLabel = styled.span`
  font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
  font-size: 20px;
  color: white;
  line-height: 1.5;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 18px;
    white-space: normal;
  }
`;

const CXRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CXThumbContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 400px;
    max-height: 430px;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    img {
      max-width: 300px;
      max-height: 320px;
    }
  }

  @media (max-width: 480px) {
    img {
      max-width: 250px;
      max-height: 270px;
    }
  }
`;

const TestimonialSection = styled.section`
  background: #21004d;
  padding: 100px 0;

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 105px;

    @media (max-width: 1024px) {
      padding: 0 32px;
    }

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }
`;

const TestimonialHeader = styled.div`
  text-align: center;
  margin-bottom: 80px;
`;

const TestimonialBadge = styled.div`
  display: inline-block;
  background: #ebb800;
  color: #000;
  padding: 8px 24px;
  border-radius: 50px;
  border: 3px solid #eb6200;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 24px;
  font-weight: normal;
  margin-bottom: 40px;
`;

const TestimonialTitle = styled.h2`
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 60px;
  font-weight: normal;
  color: white;
  line-height: 1.3;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 48px;
  }

  @media (max-width: 480px) {
    font-size: 36px;
  }
`;

const TestimonialHighlight = styled.span`
  color: #eb6200;
`;

const TestimonialGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const TestimonialCard = styled.div`
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
  }

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

const ContactSection = styled.section`
  background: #3c008a;
  padding: 100px 0;

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 105px;

    @media (max-width: 1024px) {
      padding: 0 32px;
    }

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }
`;

const ContactContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
    text-align: center;
  }
`;

const ContactText = styled.div`
  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 60px;
    font-weight: normal;
    color: white;
    line-height: 1.3;
    margin-bottom: 40px;

    @media (max-width: 768px) {
      font-size: 48px;
    }

    @media (max-width: 480px) {
      font-size: 36px;
    }
  }

  p {
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    font-size: 20px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;

    @media (max-width: 480px) {
      font-size: 18px;
    }
  }
`;

const ContactHighlight = styled.span`
  color: #eb6200;
`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FormLabel = styled.label`
  font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
  font-size: 18px;
  color: white;
  font-weight: 500;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const FormInput = styled.input`
  padding: 16px 20px;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  font-size: 16px;
  font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
  transition: all 0.3s ease;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }

  &:focus {
    outline: none;
    background: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const SubmitButton = styled.button`
  padding: 18px 32px;
  background: #eb6200;
  color: white;
  border: none;
  border-radius: 10px;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 20px;
  font-weight: normal;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 16px;

  &:hover {
    transform: translateY(-2px);
    background: #d55400;
    box-shadow: 0 8px 25px rgba(235, 98, 0, 0.3);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    padding: 16px 28px;
  }
`;

export default Pricing;